import { FileReader, FileWriter } from '@/platform'
import CustomUIData from './CustomUIData'

type ReadProgress = (value: number, message: string) => void | Promise<void>

class CustomUI {
    public CUIList: CustomUIData[] = [] //自定义UI集合

    /**
     * 同步读取高级 UI 列表。
     * @param reader 二进制读取器。
     * @param onItemRead 单个 UI 读取完成后的回调。
     * @returns 读取到的高级 UI 总数。
     */
    readBinSync(reader: FileReader, onItemRead?: (current: number, total: number) => void): number {
        this.CUIList = []
        const len = reader.readInt()
        if (len <= 0) return 0
        for (let i = 0; i < len; i++) {
            const cuidata = new CustomUIData()
            cuidata.readBin(reader)
            this.CUIList.push(cuidata)
            onItemRead?.(i + 1, len)
        }
        return len
    }

    async readBin(reader: FileReader, onProgress?: ReadProgress): Promise<void> {
        const notify = async (value: number, message: string) => {
            await onProgress?.(value, message)
        }
        await notify(0, '读取高级UI列表…')
        const len = this.readBinSync(reader, (current, total) => {
            if (current === total || current === 1 || current % 4 === 0) {
                void notify(Math.round((current / total) * 100), `读取高级UI ${current}/${total}…`)
            }
        })
        if (len <= 0) {
            await notify(100, '高级UI读取完成…')
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.CUIList.length)
        for (let i = 0; i < this.CUIList.length; i++) {
            const btn = this.CUIList[i]
            btn?.writeBin(writer)
        }
    }

    readVersionedOui(reader: FileReader): void {
        this.CUIList = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let cuidata = new CustomUIData()
            cuidata.readVersionedOui(reader.readObj(reader.readInt()))
            this.CUIList.push(cuidata)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.CUIList.length)
        for (let i = 0; i < this.CUIList.length; i++) {
            const btn = this.CUIList[i]
            btn.writeVersionedOui(writer)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        writer.writeInt(this.CUIList.length)
        for (let i = 0; i < this.CUIList.length; i++) {
            this.CUIList[i]?.writeGameBin(writer)
        }
    }
}
export default CustomUI
